export const DisputeStatus = {
  LOST: 'lost',
  NEEDS_RESPONSE: 'needs_response',
  PREVENTED: 'prevented',
  UNDER_REVIEW: 'under_review',
  WARNING_CLOSED: 'warning_closed',
  WARNING_NEEDS_RESPONSE: 'warning_needs_response',
  WARNING_UNDER_REVIEW: 'warning_under_review',
  WON: 'won',
};

export const DisputeStatusLabel = {
  [DisputeStatus.LOST]: 'Dispute Lost',
  [DisputeStatus.NEEDS_RESPONSE]: 'Dispute Reviewing',
  [DisputeStatus.PREVENTED]: 'Dispute Prevented',
  [DisputeStatus.UNDER_REVIEW]: 'Dispute Reviewing',
  [DisputeStatus.WARNING_CLOSED]: 'Dispute Closed',
  [DisputeStatus.WARNING_NEEDS_RESPONSE]: 'Dispute Reviewing',
  [DisputeStatus.WARNING_UNDER_REVIEW]: 'Dispute Reviewing',
  [DisputeStatus.WON]: 'Dispute Won',
};
